export const categoriesStatic: Record<
  string,
  { label: string; emoji: string }
> = {
  cafe: {
    label: 'Café',
    emoji: '☕',
  },
  bar: {
    label: 'Bar',
    emoji: '🍺',
  },
  restaurant: {
    label: 'Restaurant',
    emoji: '🍽️',
  },
  coworking_space: {
    label: 'Coworking Space',
    emoji: '💼',
  },
  hotel: {
    label: 'Hotel',
    emoji: '🏨',
  },
  library: {
    label: 'Library',
    emoji: '📚',
  },
  bookstore: {
    label: 'Bookstore',
    emoji: '📖',
  },
  community_center: {
    label: 'Community Center',
    emoji: '🏛️',
  },
  food_hall: {
    label: 'Food Hall',
    emoji: '🍴',
  },
  outdoor_space: {
    label: 'Outdoor Space',
    emoji: '🌳',
  },
  bakery: {
    label: 'Bakery',
    emoji: '🥐',
  },
  gym: {
    label: 'Gym',
    emoji: '💪',
  },
  spa: {
    label: 'Spa',
    emoji: '🧖',
  },
  wellness_center: {
    label: 'Wellness Center',
    emoji: '🧘',
  },
  yoga_studio: {
    label: 'Yoga Studio',
    emoji: '🧘‍♀️',
  },
  bank: {
    label: 'Bank',
    emoji: '🏦',
  },
};

export const getStaticCategory = (name: string) =>
  categoriesStatic[name] ?? {
    label: name.charAt(0).toUpperCase() + name.slice(1).replace(/_/g, ' '),
    emoji: '📍',
  };
